import { PROGRESS_START, PROGRESS_FINISH } from "../../mutation-types";
import productApi from "../../../api/product";

const defaultState = () => ({
    product: {},
    detailProduct: {}
});

const state = defaultState();

const getters = {};

const mutations = {
    listProduct(state, data) {
        state.product = Object.assign({}, state.product, data);
    },

    listDetailProduct(state, data) {
        state.detailProduct = Object.assign({}, state.detailProduct, data);
    },
};
const actions = {
    getProduct({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        productApi.getDataProduct(params).then(({ data }) => {
            commit("listProduct", data);
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },

    getDetailProduct({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        productApi.getDetailProduct(param).then(({ data: { data } }) => {
            commit("listDetailProduct", data);
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};